import React, { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export interface ProductRnd {
  id: number | null;
  product_id: number | null;
  notes?: string | "";
  allergens?: string | null;
}

export function ProductRndViewModel(
  logout: () => void,
  addSnackbar: any,
  productId: number,
) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null as any,
  });
  const [loading, setLoading] = useState(false);
  const [productRnds, setProductRnds] = useState({
    id: null,
    product_id: null,
    notes: "",
    allergens: null,
  } as ProductRnd);

  const [slideOver, setSlideOver] = useState({
    childComponent: null as any,
    open: false,
  });

  const getProductRnds = async function (product_id: number) {
    const payload: any = { product_id: product_id };
    const callResult: any = await makePostApiCall(`productRnds`, payload);

    if (callResult.success) {
      setProductRnds(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateProductRnd = async function () {
    productRnds.product_id = productId || 0;
    const payload = productRnds;
    const callResult: any = await makePostApiCall(`updateProductRnd`, payload);

    if (callResult.success) {
      setProductRnds(callResult.data);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data?.message || "Saved",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }

    return callResult;
  };

  const showErrorModal = (title: string, subtitle: string) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  return {
    getProductRnds,
    updateProductRnd,
    loading,
    productRnds,
    setSlideOver,
    slideOver,
    setProductRnds,
  };
}

export default ProductRndViewModel;
